module.exports = __webpack_public_path__ + "img/violet_132.b95c23a2.png";